import { render } from "./DynamicTab.vue?vue&type=template&id=03f05393&scoped=true"
import script from "./DynamicTab.vue?vue&type=script&lang=js"
export * from "./DynamicTab.vue?vue&type=script&lang=js"

import "./DynamicTab.vue?vue&type=style&index=0&id=03f05393&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03f05393"

export default script